
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/survey/scope-of-appointment",
      function () {
        return require("private-next-pages/account/survey/scope-of-appointment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/survey/scope-of-appointment"])
      });
    }
  